import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';

import ControllerField from 'components/Controllers/ControllerField/ControllerField';
import ControllerAutocomplete from 'components/Controllers/ControllerAutocomplete/ControllerAutocomplete';

import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { documentTypes, documentYoungTypes, eventsGeneres } from 'pages/PaymentLink/options';
import { es } from 'date-fns/locale';

const FormYoungGest = ({ control, errors, guest, sizes, setValue }) => {

  return (
    <>
      <Grid item xs={12}>
        <Typography style={{ marginTop: 10 }} ><b>Informacion del Menor</b></Typography>
      </Grid>

      <Grid item xs={4} md={6}>
        <ControllerAutocomplete
          control={control}
          name={'young_document_type_form'}
          label={'Tipo de documento'}
          options={documentYoungTypes}
          defaultValue={guest?.young_document_type ? documentYoungTypes.find(e => e.id == guest?.young_document_type) : null}
        />
      </Grid>

      <Grid item xs={8} md={6}>
        <ControllerField
          control={control}
          name={'young_document_number'}
          label={'Numero de documento'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'young_first_name'}
          label={'Nombres'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'young_last_name'}
          label={'Apellidos'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          rules={{
            required: true
          }}
          control={control}
          name='young_birthdate'
          defaultValue={guest?.young_birthdate}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
              <MobileDatePicker
                disableFuture
                {...field}
                renderInput={(props) =>
                  <TextField
                    {...props}
                    error={errors?.young_birthdate}
                    fullWidth
                  />
                }
                label={'Fecha de nacimiento'}
                placeholder={'Fecha de nacimiento'}
                openTo="year"
                inputFormat='dd/MM/yyyy'
                mask={'__/__/____'}
                maxDate={dayjs(Date.now()).subtract(5, "years")}
                minDate={dayjs(Date.now()).subtract(18, "years")}
              />
            </LocalizationProvider>
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerAutocomplete
          control={control}
          name={'young_genre_form'}
          label={'Genero'}
          options={eventsGeneres}
          defaultValue={guest?.young_genre ? eventsGeneres.find((e) => e.name == guest?.young_genre) : null}
          onChange={() => {
            setValue('young_size_id_form', null)
          }}
        />
      </Grid>

      {
        sizes &&
        <Grid item xs={12}>
          <ControllerAutocomplete
            control={control}
            name={'young_size_id_form'}
            label={'Tallas'}
            options={sizes}
            defaultValue={guest?.young_size_id ? sizes.find(e => e.id == guest?.young_size_id) : null}
          />
        </Grid>
      }

      <Grid item xs={12}>
        <Typography style={{ marginTop: 10 }} ><b>Informacion del Padre/Madre/Acudiente</b></Typography>
      </Grid>

      <Grid item xs={4} md={6}>
        <ControllerAutocomplete
          control={control}
          name={'parent_document_type_form'}
          label={'Tipo de documento'}
          options={documentTypes}
          defaultValue={guest?.parent_document_type ? documentTypes.find(e => e.id == guest?.parent_document_type) : null}
        />
      </Grid>

      <Grid item xs={8} md={6}>
        <ControllerField
          control={control}
          name={'parent_document_number'}
          label={'Numero de documento'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'parent_first_name'}
          label={'Nombres'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'parent_last_name'}
          label={'Apellidos'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'parent_email'}
          label={'Correo'}
          allowPaste={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ControllerField
          control={control}
          name={'parent_phone'}
          label={'Telefono'}
          allowPaste={false}
        />
      </Grid>
    </>
  )

}

export default FormYoungGest
